import { render, staticRenderFns } from "./SystemEventTable.vue?vue&type=template&id=3b5b223e&scoped=true"
import script from "./SystemEventTable.vue?vue&type=script&lang=js"
export * from "./SystemEventTable.vue?vue&type=script&lang=js"
import style0 from "./SystemEventTable.vue?vue&type=style&index=0&id=3b5b223e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b223e",
  null
  
)

export default component.exports